import { injectable } from "inversify";
import databaseInstance from "../../index";

@injectable()
export class TeamService {
  private dbInstance: any = databaseInstance;

  private static instance: TeamService;

  constructor() {
    TeamService.instance = this;
  }

  public static getInstance() {
    if (!TeamService.instance) {
      TeamService.instance = new TeamService();
    }
    return TeamService.instance;
  }

  public getTeamMembers: (groupId: number, query?: string) => Promise<void> = (
    groupId,
    query = ""
  ) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/team-members${query}`)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public getTeamRoles: () => Promise<void> = () => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/roles`)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public loadMore: (url: string) => Promise<void> = url => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance.get(url).then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  /**
   *
   * @param groupId
   * @param searchString
   * @returns
   * @todo shift to group service (or use already implemented)
   */
  public searchGroupMembers: (
    groupId: number,
    searchString: string
  ) => Promise<void> = (groupId, searchString) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/memberships${searchString.length >= 2 ? `?nsearch=${searchString}` : ''}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

  public editTeamMemberPermission: (
    groupId: number,
    member: any
  ) => Promise<void> = (groupId, member) => {
    const serverMember = {
      group_member_id: member.groupMemberId,
      role_id: member.roleId
    };

    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/team-members`, serverMember)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          resolve(error)
          new Error("Something went wrong!")
        });
    });
  };

  public removeTeamMember: (
    groupId: number,
    memberId: number
  ) => Promise<void> = (groupId, memberId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`/groups/${groupId}/team-members/${memberId}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

  public checkCommunitySupport: (
    groupId: number
  ) => Promise<void> = groupId => {
    return new Promise((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/community-support-check`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

  public addCommunitySupport: (groupId: number) => Promise<void> = groupId => {
    return new Promise((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/team-members/support`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

  public assignRolesAndPermissions: (groupId: number, payload: any) => Promise<void> = (groupId, payload) => {
    return new Promise((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/team-members`, payload)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

  public fetchPermissions: () => Promise<void> = () => {
    return new Promise((resolve, reject) => {
      this.dbInstance
        .get(`/permissions`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

  public fetchRoleLabels: (groupId: number) => Promise<void> = (groupId) => {
    return new Promise((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/role-labels`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

  public addCustomRoleLabel: (groupId: number, payload: any) => Promise<void> = (groupId, payload) => {
    return new Promise((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/community-role-labels`, payload)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

  public fetchCustomRoleLabels: (groupId: number) => Promise<void> = (groupId) => {
    return new Promise((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/community-role-labels`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

  public deleteCustomRoleLabels: (groupId: number, roleLabelID: number) => Promise<void> = (groupId, roleLabelID) => {
    return new Promise((resolve, reject) => {
      this.dbInstance
        .delete(`/groups/${groupId}/community-role-labels/${roleLabelID}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

  public editCustomRoleLabels: (groupId: number, roleLabelID: number, payload: any) => Promise<void> = (groupId, roleLabelID, payload) => {
    return new Promise((resolve, reject) => {
      this.dbInstance
        .put(`/groups/${groupId}/community-role-labels/${roleLabelID}`, payload)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

}
